export const SETTINGS_TABS = {
    CALENDAR: 'calendar_tab',
    DEVICES: 'devices_tab',
    MORE: 'more_tab',
    PROFILE: 'profile_tab'
};

/**
 * View ID for the Settings modal.
 */
export const SETTINGS_VIEW_ID = 'SETTINGS_VIEW_ID';


export const EMAIL_REGEX = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
